<template>
  <div>
    <span class="switch switch-outline switch-icon switch-success">
      <label>
        <input
          :value="value"
          @change="setChecked"
          :checked="isChecked"
          v-bind="$attrs"
        />
        <span></span>
      </label>
    </span>
  </div>
</template>

<script>
export default {
  name: "FormSwitch",
  inheritAttrs: false,
  props: {
    /**
     * V-Model
     */
    value: {}
  },
  data() {
    return {};
  },
  components: {},
  mounted() {},
  computed: {
    isChecked() {
      return !!this.value;
    }
  },
  methods: {
    setChecked($event) {
      //  trigger a mutation, or dispatch an action
      this.$emit("input", $event.target.checked);
    }
  }
};
</script>
